import React, { Component } from "react";
import {
  pickKeyMarketAvgsRowForArea,
  getSortedKmaBoxes,
  getKmaHeaderFields,
  getKmaDurationLabel,
  formatKmaAreaDuration,
  normalizeKmaDurationValue,
  hasKmaBoxValue,
  formatKmaBoxValue,
  getBoxKey,
} from "./hotBoxesJuneUtils";

const KMA_DURATION_OPTIONS = [
  { value: "6m", label: "Last 6 Months" },
  { value: "12m", label: "Last 12 Months" },
];

export const DEFAULT_FOOTER_1 =
  "Home values remain strong, reflecting continued demand for properties in the area.";
export const DEFAULT_FOOTER_2 =
  "Properties are moving steadily as buyers prioritize value, presentation, and pricing strategy.";

export const footerLine = (value, fallback) => {
  const text = value == null ? "" : String(value).trim();
  if (!text || text === "-") return fallback;
  return text;
};

class MarketInAMinutePrint extends Component {
  componentDidMount() {
    require("./print.scss");
  }

  render() {
    const {
      keyMarketAvgsList,
      currentArea,
      kmaRow: kmaRowOverride,
      fromEditor,
      canEdit,
      onEditBox,
      onEditFooter,
      onDurationChange,
      durationLoading,
      textSaving,
      apiError,
      quarterlyAreaTable,
    } = this.props;
    const sixMonthTrends = (quarterlyAreaTable?.marketTrends || []).find(
      (trend) => trend.TrendName === "6-Months Trending",
    );
    const { PropertyTypeTitle } = sixMonthTrends || {};

    const kmaRow =
      kmaRowOverride ||
      pickKeyMarketAvgsRowForArea(keyMarketAvgsList, currentArea);
    const boxes = getSortedKmaBoxes(kmaRow);
    const { title, subtitle } = getKmaHeaderFields(kmaRow, currentArea);
    const selectedDuration = normalizeKmaDurationValue(
      kmaRow?.kmaAreaDuration || kmaRow?.kmaDuration || "6m",
    );
    const durationLabel =
      (kmaRow && getKmaDurationLabel(kmaRow)) ||
      formatKmaAreaDuration(selectedDuration);
    const footer1 = footerLine(kmaRow?.kmaFooter1, DEFAULT_FOOTER_1);
    const footer2 = footerLine(kmaRow?.kmaFooter2, DEFAULT_FOOTER_2);

    const editBusy = durationLoading || textSaving;

    return (
      <div className={`market-in-a-min${fromEditor ? " from-editor" : ""}`}>
        {/*{canEdit ? (
          <div className="market-in-a-min-duration-controls">
            <select
              className="market-in-a-min-duration-select"
              value={selectedDuration}
              onChange={onDurationChange}
              disabled={editBusy}
              aria-label="Market averages duration"
            >
              {KMA_DURATION_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        ) : null}*/}
        <header className="market-in-a-min-header">
          <h1 className="market-in-a-min-title">{title}</h1>
          {subtitle ? (
            <h2 className="market-in-a-min-subtitle">{subtitle}</h2>
          ) : null}
        </header>

        <div className="market-in-a-min-meta">
          <div className="market-in-a-min-meta-right-wrap">
            {durationLabel ? (
              <p className="market-in-a-min-meta-right">
                {PropertyTypeTitle
                  ? PropertyTypeTitle
                  : "Past 6 Months Trending"}
              </p>
            ) : null}
          </div>
        </div>

        {apiError ? (
          <p className="market-in-a-min-api-error" role="alert">
            {apiError}
          </p>
        ) : null}

        <div className="market-in-a-min-columns-wrapper">
          <div className="market-in-a-min-columns">
            {boxes.map((box) => (
              <div className="market-in-a-min-column" key={getBoxKey(box)}>
                {hasKmaBoxValue(box) ? (
                  <p className="market-in-a-min-stat-value">
                    {formatKmaBoxValue(box)}
                  </p>
                ) : (
                  <p
                    className="market-in-a-min-stat-value market-in-a-min-stat-value-empty"
                    aria-hidden="true"
                  />
                )}
                {box.kmaTitle ? (
                  <div className="market-in-a-min-stat-label-wrapper">
                    <p className="market-in-a-min-stat-label">{box.kmaTitle}</p>
                  </div>
                ) : null}
              </div>
            ))}
          </div>
          {canEdit && boxes.length > 0 ? (
            <div className="market-in-a-min-edit-actions">
              {boxes.map((box) => (
                <div
                  className="market-in-a-min-edit-actions-cell"
                  key={`edit-${getBoxKey(box)}`}
                >
                  <button
                    type="button"
                    className="market-in-a-min-edit-text-btn"
                    onClick={() => onEditBox(box)}
                    disabled={editBusy}
                  >
                    Edit Text
                  </button>
                </div>
              ))}
            </div>
          ) : null}
        </div>
        <div className="market-in-a-min-footer">
          {footer1 ? <p>{footer1}</p> : null}
          {footer2 ? <p>{footer2}</p> : null}
          {canEdit ? (
            <button
              type="button"
              className="market-in-a-min-edit-text-btn market-in-a-min-edit-footer-btn"
              onClick={onEditFooter}
              disabled={editBusy}
            >
              Edit Footer
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default MarketInAMinutePrint;
